import React, { memo } from "react";
import ActivityIcon from "./ActivityIcon";

const ActivitiesIcons = memo(({ handleClick, clickedActivities, activitiesTags }) => {
	return (
		<div className="flex mx-2 flex-wrap">
			{activitiesTags.map(({ id, name, color, icon, iconMui }) => {
				return (
					<div
						key={id}
						onClick={() => handleClick(id)}
						style={{ backgroundColor: clickedActivities.includes(id) ? color : "#fff" }}
						className="cursor-pointer mx-1 p-1 border-2 border-gray-800 rounded-full"
					>
						<ActivityIcon iconMui={iconMui} icon={icon} />
					</div>
				);
			})}
		</div>
	);
});

export default ActivitiesIcons;
